module.exports = {
          srcSet: __webpack_public_path__ + "48639b59d383e920fb25b5c5a61a9452-96.png"+" 96w",
          images:[ {path: __webpack_public_path__ + "48639b59d383e920fb25b5c5a61a9452-96.png",width: 96,height: 861}],
          src: __webpack_public_path__ + "48639b59d383e920fb25b5c5a61a9452-96.png",
          toString:function(){return __webpack_public_path__ + "48639b59d383e920fb25b5c5a61a9452-96.png"},
          
          width: 96,
          height: 861
        }